module.exports = __webpack_public_path__ + "static/media/PB_G_16.850f0af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_16.png
// module id = 229
// module chunks = 0